/* supported modules for rich text editor */
export enum RichTextEditorType {
  Simple = 'simple',
  Advanced = 'advanced'
}
